import React from "react";
import styled from "styled-components";
import { Box } from "@edricphan2022/uikit";
import Picture from "../../components/Picture";
import Img from "../../assets/servicez/MaskGroup.svg";
import Img1 from "../../assets/servicez/rubic.svg";
import Img2 from "../../assets/servicez/GroupBox.svg";
const PannerContainer = styled(Box)`
  width: calc(100% - 32px);
  height: 400px;
  background-color: #333333;
  position: absolute;
  top: -196px;
  transform: translateY(-50%);
  border-radius: 10px;
  background-image: url('${Img}');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;

  .pannerRubic {
    position: absolute;
    top: -20px;
    width: 100%;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
  .pannerRubicBox1 {
    position: absolute;
    width: 60px;
    height: 60px;
    bottom: 50%;
    left: 50%;
    transform: translateY(25%) translateX(-511%);
    animation-name: translateY1;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  .pannerRubicBox2 {
    position: absolute;
    width: 60px;
    height: 60px;
    bottom: 0%;
    left: 50%;
    transform: translateX(-90%) translateY(-90%);
    animation-name: translateY2;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  .pannerRubicBox3 {
    position: absolute;
    width: 60px;
    height: 60px;
    top: 25%;
    left: 50%;
    transform: translateX(305%) translateY(-90%);
    animation-name: translateY3;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  .pannerRubicBox4 {
    position: absolute;
    width: 60px;
    height: 60px;
    bottom: 10%;
    left: 50%;
    transform: translateX(305%) translateY(-90%) rotateZ(-60deg);
    animation-name: translateY4;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes translateY1 {
    0% {
      bottom: 45%;
    }
    50% {
      bottom: 56%;
    }
    100% {
      bottom: 45%;
    }
  }
  @keyframes translateY2 {
    0% {
      bottom: 0%;
    }
    50% {
      bottom: -11%;
    }
    100% {
      bottom: 0%;
    }
  }
  @keyframes translateY3 {
    0% {
      top: 30%;
    }
    50% {
      top: 19%;
    }
    100% {
      top: 30%;
    }
  }
  @keyframes translateY4 {
    0% {
      bottom: 10%;
    }
    50% {
      bottom: 0%;
    }
    100% {
      bottom: 10%;
    }
  }
  @media (max-width: 668px) {
    height: 297px;
    .pannerRubicBox1,
    .pannerRubicBox2,
    .pannerRubicBox3,
    .pannerRubicBox4 {
      width: 45px;
      height: 45px;
    }
  }

  @media (max-width: 500px) {
    height: 297px;
    .pannerRubicBox1 {
      left: 62%;
    }

    .pannerRubicBox3 {
      left: 40%;
    }

    .pannerRubicBox4 {
      left: 40%;
      bottom: 0%;
    }
  }

  @media (max-width: 395px) {
    height: 297px;
    .pannerRubicBox1 {
      left: 70%;
    }
  }
`;
const Panner = () => {
  return (
    <PannerContainer>
      {/* <Picture className="pannerBG" url={Img} /> */}
      <div className="PannerGroup">
        <Picture className="pannerRubic" url={Img1} />
      </div>
    </PannerContainer>
  );
};
export default Panner;
